module.exports = { apiServer: 'https://api.uat.in-store.hk', AdminServer: 'https://admin.uat.in-store.hk' };
